import requests from "./httpService";

const AdminServices = {

    login: async (body) => {
        return requests.post(`/auth/admin/login`, body);
    },

    getMyProfile: async () => {
        return requests.get(`/admin/profile`);
    },
    updateMe: async (body) => {
        return requests.patch(`/admin/updateMe`, body);
    },
    updatePassword: async (body) => {
        return requests.patch(`/admin/change-password`, body);
    },
    dashboard: async () => {
        return requests.get(`/admin/dashboard`);
    },

    getAllAdmin: async () => {
        return requests.get(`/admin`);
    },
    createAdmin: async (body) => {
        return requests.post(`/admin/`, body);
    },
    updateAdmin: async (id, body) => {
        return requests.patch(`/admin/${id}`, body);
    },
    deleteAdmin: async (id) => {
        return requests.delete(`/admin/${id}`);
    },
}

export default AdminServices;
